
import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";



class InsaatSinifiAPI extends BaseAPI {


  constructor() {
    const baseUrl = environment.API_URL + "InsaatSinifiListe";
    super(baseUrl);
  }


  getInsaatSinifiListe(insaatSinifiKodu?: number) {
    return this.get("", { params: { insaatSinifiKodu: insaatSinifiKodu } })

  }

}
export default new InsaatSinifiAPI();
